import React from 'react'
import { Card, Icon, Grid, Image, Popup } from 'semantic-ui-react';
import { dispatch } from '@rematch/core';
import EllipsisTooltip from './../../../../common/EllipsisTooltip';
import MomentDate from '../../../../common/MomentDate';
import Progress from 'react-progressbar';
import noImage from '../../../../../images/common/broken-image.png'

let timer = 0;
let delay = 200;
let prevent = false;
class LibraryCard extends React.Component {
    constructor(props) {
        super(props);
        this.cardClick = this.cardClick.bind(this);
        this.generatingCardClick = this.generatingCardClick.bind(this);
        this.generatingCardClickOpenModal = this.generatingCardClickOpenModal.bind(this);
    }

    componentWillMount() {
        dispatch.lifeCycle.setLibraryCardIndex(null)
        dispatch.lifeCycle.setArrangementPaneActiveButtonFlag(0)
    }

    handleClick(PracticeLibrary, key) {
        if(PracticeLibrary.status === -1 && PracticeLibrary.playbookGenerationStatus === -1){
            let thisClick = this;
            timer = setTimeout(function () {
                if (!prevent) {
                    thisClick.generatingCardClick(PracticeLibrary, key);
                }
                prevent = false;
            }, delay);    
        }
        else if(PracticeLibrary.status === -1 && PracticeLibrary.playbookGenerationStatus === 0){
            let thisClick = this;
            timer = setTimeout(function () {
                if (!prevent) {
                    thisClick.generatingCardClickOpenModal(PracticeLibrary, key);
                }
                prevent = false;
            }, 10);    
        }
        else if(PracticeLibrary.status !== -1){
        let thisClick = this;
        timer = setTimeout(function () {
            if (!prevent) {
                thisClick.cardClick(PracticeLibrary, key);
            }
            prevent = false;
        }, delay);
      }
    }

    handleDoubleClick(PracticeLibrary, key) {
      if(PracticeLibrary.status !== -1 && (PracticeLibrary.playbookGenerationStatus > 0 || typeof PracticeLibrary.playbookGenerationStatus === 'undefined')){
        clearTimeout(timer);
        prevent = true;
        this.doDoubleClickAction(PracticeLibrary, key);
      }
    }

    doDoubleClickAction(PracticeLibrary, key) {
        this.cardClick(PracticeLibrary, key);
        dispatch.lifeCycle.splitAt("60%");
    }
    generatingCardClickOpenModal(PracticeLibrary, key){
        dispatch.lifeCycle.getPackAndUpdateSelectedPracticeLibary(PracticeLibrary._id);
        dispatch.lifeCycle.setSelectedPracticeLibrary(PracticeLibrary);
    }

    generatingCardClick(PracticeLibrary, key){
        dispatch.lifeCycle.setInitState(PracticeLibrary.status)
        dispatch.createPack.setSelectedActivityData({})
        dispatch.lifeCycle.setLibraryCardIndex(key)
        dispatch.lifeCycle.getPackAndUpdateSelectedPracticeLibary(PracticeLibrary._id);
        dispatch.lifeCycle.isPlaybookImportLoading(false);
        dispatch.lifeCycle.setSelectedPracticeLibrary(PracticeLibrary);
        dispatch.integrations.getEntityIntegrationConfig({entityId: PracticeLibrary._id })
        dispatch.lifeCycle.modalEditOpen(true);
        dispatch.lifeCycle.updateEditCardImageAsync(null);
        dispatch.lifeCycle.setParticipantsAsync([]);
        dispatch.lifeCycle.setInvitedParticipantAsync([]);
        dispatch.lifeCycle.setIdToCenterPosition(PracticeLibrary._id);
        dispatch.lifeCycle.activePage('libraryCard');
        dispatch.lifeCycle.setPlaybookError(null);
        dispatch.app.setCollapsedResourcePaneIndexTemp(null)
    }
    cardClick(PracticeLibrary, key) {
        dispatch.lifeCycle.getAllPlayBooksFromBaseId(PracticeLibrary.baseId)
        dispatch.lifeCycle.setInitState(PracticeLibrary.status)
        dispatch.createPack.setSelectedActivityData({})
        dispatch.lifeCycle.setLibraryCardIndex(key)
        dispatch.lifeCycle.getPackAndUpdateSelectedPracticeLibary(PracticeLibrary._id);
        dispatch.lifeCycle.isPlaybookImportLoading(false);
        dispatch.lifeCycle.setSelectedPracticeLibrary(PracticeLibrary);
        dispatch.lifeCycle.getInviteByPackIdAsync(PracticeLibrary._id);

        dispatch.integrations.getEntityIntegrationConfig({entityId: PracticeLibrary._id })

        dispatch.lifeCycle.setArrangementPaneFlag(true);
        dispatch.lifeCycle.modalEditOpen(true);
        dispatch.lifeCycle.updateEditCardImageAsync(null);

        dispatch.lifeCycle.setParticipantsAsync([]);
        dispatch.lifeCycle.setInvitedParticipantAsync([]);
        dispatch.lifeCycle.setIdToCenterPosition(PracticeLibrary._id);
        dispatch.lifeCycle.splitAt("60%");
        dispatch.lifeCycle.activePage('libraryCard');
        dispatch.lifeCycle.setPlaybookError(null);
        //this.props.setCollapsedResourcePaneIndex(null);
        dispatch.app.setCollapsedResourcePaneIndexTemp(null)
        // Below code is disabled, new code block added (KLM-8923)
        // switch (PracticeLibrary.status) {
        //     case 0:
        //         return dispatch.lifeCycle.showResourecePane("Indesign");
        //     case 1:
        //         return dispatch.lifeCycle.showResourecePane("Indesign");
        //     case 2:
        //         return dispatch.lifeCycle.showResourecePane("Indesign");
        //     case 4:
        //         return dispatch.lifeCycle.showResourecePane("PublishedPack");
        //     case 5:
        //         return dispatch.lifeCycle.showResourecePane("PublishedPack");
        //     default:
        //         return null;
        // }
        if(PracticeLibrary.status === 0) {
            return dispatch.lifeCycle.showResourecePane("Indesign");
        }
        else if(PracticeLibrary.status === 1) {
            return dispatch.lifeCycle.showResourecePane("Indesign");
        }
        else if(PracticeLibrary.status === 2) {
            return dispatch.lifeCycle.showResourecePane("Indesign");
        }
        else if(PracticeLibrary.status === 4) {
            return dispatch.lifeCycle.showResourecePane("PublishedPack");
        }
        else if(PracticeLibrary.status === 5) {
            return dispatch.lifeCycle.showResourecePane("PublishedPack");
        }
        else {
            return null
        }
    }

    addDefaultSrc = (ev) => {
        ev.target.src = noImage
    }

    render() {
        let displayCard;
        let participantsCount = 0;
        let calProgress = this.props.PracticeLibrary && this.props.PracticeLibrary.generativeLogs
         && this.props.PracticeLibrary.generativeLogs.totalPhases 
         && this.props.PracticeLibrary.generativeLogs.phasesCompleted ?
         this.props.PracticeLibrary.generativeLogs.phasesCompleted.length / this.props.PracticeLibrary.generativeLogs.totalPhases * 100 : 0

        if (this.props.PracticeLibrary.participants) {
            if (this.props.PracticeLibrary.participants.length !== 0) {
                participantsCount = this.props.PracticeLibrary.participants.length;
            }
        }
        let objValidation = Object.entries(this.props.selectedPracticeLibrary).length !== 0 && this.props.selectedPracticeLibrary.constructor === Object
        const headerStyle = {
            backgroundColor: this.props.PracticeLibrary && this.props.PracticeLibrary.playbookGenerationStatus && this.props.PracticeLibrary.playbookGenerationStatus === -1 ? '#FFC0CB' : '#FFFFFF'
          }
        displayCard = <Card
            id={this.props.PracticeLibrary._id}
            className={(objValidation && this.props.PracticeLibrary._id === this.props.selectedPracticeLibrary._id) ? "packCard activeCard" : "packCard "}
            style={{ float: "left" }}
            onClick={() => { this.handleClick(this.props.PracticeLibrary, this.props.index) }}
            onDoubleClick={() => this.handleDoubleClick(this.props.PracticeLibrary, this.props.index)}
        >

            <Card.Header style={headerStyle} onMouseEnter={() => dispatch.app.setHelpContext("Playbook Tile")}>
                <Popup
                    inverted
                    className="popupStyled"
                    content={this.props.PracticeLibrary.name}
                    trigger={<div>{this.props.PracticeLibrary.name && this.props.PracticeLibrary.name.length > 24 ? `${this.props.PracticeLibrary.name.slice(0, 21)}...` : this.props.PracticeLibrary.name}</div>}
                    disabled={this.props.PracticeLibrary.name && this.props.PracticeLibrary.name.length <= 24}
                  /></Card.Header>
            <Card.Content >
            {(objValidation && this.props.PracticeLibrary._id === this.props.selectedPracticeLibrary._id) ?
                <Image style={{"filter": "blur(2px)"}} onError={this.addDefaultSrc} className="fitImage" src={this.props.PracticeLibrary.picture} /> : 
                <Image onError={this.addDefaultSrc} className="fitImage" src={this.props.PracticeLibrary.picture}/>
            }
                {(objValidation && this.props.PracticeLibrary._id === this.props.selectedPracticeLibrary._id) &&
                    <Grid>
                        <Grid.Row style={{ "position":"absolute", "top":"34px", "paddingTop": '24px', "paddingBottom": '0' }}>
                            <Grid.Column width={8}>
                            <div className="ui blue circular label cardLabel" style={{ "margin": "5px 0 0 10px","width":'51px' }}>
                                <Icon name="sitemap" style={{ "margin": "0 5px 0 0" }} />

                                <Popup trigger={
                                    <span >
                                        {this.props.selectedPracticeLibrary.countList ? this.props.selectedPracticeLibrary.countList.activityCount : 0}
                                    </span>
                                }
                                    content="Activity"
                                    position='right center'
                                    className="popupStyled"
                                    inverted
                                />
                            </div>

                            </Grid.Column>
                            <Grid.Column width={8}>
                            <div className="ui blue circular label cardLabel" style={{ "margin": "5px 0 0 10px","width":'51px' }}>
                                <Icon name="group" style={{ "margin": "0 5px 0 0" }} />

                                <Popup trigger={
                                    <span >
                                        {participantsCount}
                                    </span>
                                }
                                    content="Participant"
                                    position='left center'
                                    className="popupStyled"
                                    inverted
                                />
                            </div>

                            </Grid.Column>
                        </Grid.Row>
                        {(this.props.PracticeLibrary.status === 4) ?
                            <Grid.Row style={{ "position":"absolute", "top":"77px", "paddingTop": '5px', "paddingBottom": '0' }}>
                                <Grid.Column width={8}>
                                <div className="ui blue circular label cardLabel" style={{ "margin": "10px 0 0 10px","width":'51px' }}>
                                    <Icon name="thumbs up" style={{ "margin": "0 5px 0 0" }} />

                                    <Popup trigger={
                                        <span >0</span>
                                    }
                                        content="Likes"
                                        position='right center'
                                        className="popupStyled"
                                        inverted
                                    />
                                </div>


                                </Grid.Column>
                                <Grid.Column width={8}>
                                <div className="ui blue circular label cardLabel" style={{ "margin": "10px 0 0 10px","width":'51px' }}>
                                
                                    <Icon name="copy" style={{ "margin": "0 5px 0 0" }} />

                                    <Popup trigger={
                                        <span >
                                            {this.props.selectedPracticeLibrary && this.props.selectedPracticeLibrary.totalIntances ? this.props.selectedPracticeLibrary.totalIntances : 0}
                                        </span>
                                    }
                                        content="Usage"
                                        position='left center'
                                        className="popupStyled"
                                        inverted
                                    />
                                </div>


                                </Grid.Column>
                            </Grid.Row>
                            : ""
                        }
                        <Grid.Row style={{ "padding": "0 0 0 0", 'fontSize': '10px', 'position': 'absolute', 'bottom': '0','color':'white' }}>
                            <Grid.Column width={3}>
                                V{this.props.PracticeLibrary.version}
                            </Grid.Column>
                            <Grid.Column textAlign="right" width={13} style={{ fontSize: '9px' }}>
                                Modified on <MomentDate date={this.props.PracticeLibrary.updatedAt} />
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                    
                }
                {/* 
        0 : In design
        1 : In Review
        2 : Approved
        3 : Rejected
        4 : Publish
        5 : Depricated 
        6 : Clone / Purchased       
    */}
                {this.props.PracticeLibrary.status === 0 ?
                    <div className="badge badgeIndesign">In Design </div>
                    : this.props.PracticeLibrary.status === 1 ? <div className="badge badgeInReview">Review request </div>
                        : this.props.PracticeLibrary.status === 2 ? <div className="badge badgeApproved">Approved </div>
                            : this.props.PracticeLibrary.status === 3 ? <div className="badge badgeRejected">Rejected </div>
                                : this.props.PracticeLibrary.status === 4 ? <div className="badge badgePublished">Published </div>
                                    : this.props.PracticeLibrary.status === 5 ? <div className="badge badgeDepricated">Inactive </div>
                                        : this.props.PracticeLibrary.status === 6 ? <div className="badge badgeCloned">Cloned / Purchased </div>
                                          : this.props.PracticeLibrary.status === -1 ? <div className="badge badgeCloned">Generating </div>
                                            : ''}

                <div className="badgeRight">

                    <span
                        className={`badgeblock ${this.props.PracticeLibrary.scope === 'Public' ? 'badgeRightPublic' : ''} 
                    ${this.props.PracticeLibrary.scope === 'Private' ? 'badgeRightPrivate' : ''}`}>
                        {this.props.PracticeLibrary.scope === "Private" ? this.props.PracticeLibrary.accountLevelAccess ? "Account" : "Workspace" : this.props.PracticeLibrary.scope}
                    </span>
                </div>
            </Card.Content>
            {(this.props.PracticeLibrary.status === -1) ?
                <div className="cardProgress progress-active">

                    <Popup
                        trigger={<Progress completed={calProgress ? calProgress : 0} />}
                        content={`${calProgress ? Number(calProgress).toFixed(0) : 0}%`}
                        position="top center"
                        className="popupStyled"
                        inverted
                    />
                </div>
            : ""}
        </Card>
        return (
            displayCard
        )
    }
}

export default LibraryCard;